module.exports = __webpack_public_path__ + "static/img/5-2.2ef40f56.png";